import Alert from '@shared/components/atoms/Alert/Alert';
import useAlertStore from '@entities/ui/model/useAlertStore';
import ApprovalLineGuideModal from '@shared/components/modal/ApprovalLineGuideModal';
import ErrorBoundary from '@shared/components/atoms/ErrorBoundary';

import AppProvider from './providers';
import MobileAuthPreloader from './providers/MobileAuthPreloader';
import Router from './Router';

function App() {
  const { isOpen, message, disableOverlayClick, closeAlert } = useAlertStore();

  return (
    <AppProvider>
      <MobileAuthPreloader>
        <ErrorBoundary>
          <Router />
        </ErrorBoundary>
        <ApprovalLineGuideModal />
        <Alert
          isOpen={isOpen}
          message={message}
          onClose={closeAlert}
          disableOverlayClick={disableOverlayClick}
        />
      </MobileAuthPreloader>
    </AppProvider>
  );
}

export default App;
